import { useSelector } from 'react-redux'
import * as selectors from '../selectors'

export default function useEducationFeatures() {
  return useSelector(selectors.educationFeatures)
}
